// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__6wJ39","info":"PatientInfo_info__1li_6"};